"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mongoose_1 = require("mongoose");
const volumeSchema = new mongoose_1.Schema({
    name: String,
    user: {
        type: mongoose_1.Schema.Types.ObjectId,
        required: false,
        ref: "User",
        default: null,
    },
    team: {
        type: mongoose_1.Schema.Types.ObjectId,
        required: false,
        ref: "Team",
        default: null,
    },
    subscription: {
        type: mongoose_1.Schema.Types.ObjectId,
        required: true,
        ref: "Subscription",
    },
    size: { type: Number, required: true },
    mount_path: { type: String },
}, {
    timestamps: {
        createdAt: "created_at",
        updatedAt: "updated_at",
    },
});
exports.default = (0, mongoose_1.model)("Volume", volumeSchema);
